<template>
  <div>
    <div ref="modal" style="display: none">

      <div class="mb-3">
        <b>{{ id ? 'Редактирование района' : 'Создание района' }}</b>
      </div>

      <district-form-block
          ref="form"
          :id="id"
          :defaultParams="defaultParams"
          @save="update"
          @add="update"
          @cancel="fancyboxClose"
      />

    </div>
  </div>

</template>

<script>

import DistrictFormBlock from "@/views/District/DistrictFormBlock";

export default {
  components: {DistrictFormBlock},
  data() {
    return {
      id: null,
    }
  },
  props: {
    defaultParams: {
      type: Object,
      default: () => ({})
    },
  },
  methods: {
    openModal(data_id) {
      this.id = data_id
      setTimeout(() => {
        this.$refs.form.init();
        this.fancybox(this.$refs.modal)
      }, 0)
    },
    update() {
      this.$emit('update')
      this.fancyboxClose()
    },
  },
}
</script>